import { useMutation } from "@shared/lib/hooks";
import { BriefConfigService } from "../services/briefConfigService";
import { BRIEF_CONFIG_QUERY_KEY } from "@entities/brief/lib/constants";
import { ToastService } from "@shared/lib/services";

export function useDeleteBriefConfigTask(briefId: string) {
  const {
    mutate: deleteTask,
    isLoading: isDeleting,
    isSuccess: isDeleted,
    variables,
  } = useMutation({
    mutationFn: ({
      briefId,
      deliverableConfigRefId,
      taskId,
    }: {
      briefId: string;
      deliverableConfigRefId: string;
      taskId: string;
    }) =>
      BriefConfigService.deleteBriefConfigTask({
        briefId,
        deliverableConfigRefId,
        taskId,
      }).catch(async (err) => {
        const responseBody = await err.response.json();
        ToastService.error(responseBody.msg);
        throw err;
      }),
    options: {},
    onSuccess: (c) => {
      c.invalidateQueries({ queryKey: BRIEF_CONFIG_QUERY_KEY(briefId) });
    },
  });

  return {
    deleteTask,
    isDeleting,
    isDeleted,
    variables,
  };
}
